import { ProductAttributeFilter } from "@interfaces/components/product-filters.interface";
import { decode } from "html-entities";

interface Props {
  attributeFilters: ProductAttributeFilter[];
}

const SubcategoriesSelected = ({ attributeFilters }: Props) => {
  return (
    <div className="filter-category rounded-2">
      <div className="filter-title">
        <h3>หมวดหมู่</h3>
      </div>
      <ul>
        {attributeFilters.map(({ display, value }) => (
          <li key={value}>
            <a>{decode(display)}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SubcategoriesSelected;
